import { C_TEAL, rgba } from '../utils/palette';
import { setupCanvas } from '../utils/canvas';
import { YEARS } from '../utils/constants';

export const CHART_KEY = [
    '% share of last year\'s points across all ranked riders',
    'Longer bar = stronger historical claim to win this season',
    'Based on last year only · does not factor trajectory · tap for detail',
];

export function renderPredictionBar(canvas, tooltip, riders) {
    if (!canvas || !riders.length) return;

    const lastYear = YEARS[YEARS.length - 1];
    const withPts  = riders.filter(r => r.pointsByYear?.[lastYear] > 0);
    if (!withPts.length) return;

    const total = withPts.reduce((s, r) => s + r.pointsByYear[lastYear], 0);
    const top   = withPts.slice(0, 15).map(r => ({
        name: r.rider,
        pos:  r.position,
        pct:  r.pointsByYear[lastYear] / total,
    }));

    const w    = canvas.parentElement.clientWidth || 280;
    const rowH = 16;
    const h    = top.length * rowH + 8;
    const ctx  = setupCanvas(canvas, w, h);
    ctx.clearRect(0, 0, w, h);

    const pad  = { top: 4, right: 48, bottom: 4, left: 24 };
    const barW = w - pad.left - pad.right;
    const maxP = top[0].pct;

    const hitRows = [];
    top.forEach((r, i) => {
        const y  = pad.top + i * rowH;
        const bw = (r.pct / maxP) * barW;

        ctx.fillStyle = rgba(C_TEAL, 0.15 + r.pct / maxP * 0.55);
        ctx.fillRect(pad.left, y + 3, bw, rowH - 6);

        ctx.fillStyle = '#bbb';
        ctx.font = '8px monospace';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        ctx.fillText(r.pos, pad.left - 4, y + rowH / 2);

        ctx.fillStyle = '#555';
        ctx.textAlign = 'right';
        ctx.fillText((r.pct * 100).toFixed(1) + '%', w - pad.right + 40, y + rowH / 2);

        hitRows.push({ y, rowH, name: r.name, pct: r.pct });
    });
    ctx.textBaseline = 'alphabetic';

    if (canvas._predMM) canvas.removeEventListener('mousemove',  canvas._predMM);
    if (canvas._predML) canvas.removeEventListener('mouseleave', canvas._predML);
    canvas._predMM = (e) => {
        const rect = canvas.getBoundingClientRect();
        const my   = e.clientY - rect.top;
        const hit  = hitRows.find(r => my >= r.y && my < r.y + r.rowH);
        if (hit && tooltip) {
            tooltip.textContent   = `${hit.name}  ${(hit.pct * 100).toFixed(2)}%`;
            tooltip.style.display = 'block';
            const _mx = e.clientX - rect.left;
            const _tw = tooltip.offsetWidth;
            tooltip.style.left    = (_mx + 10 + _tw > canvas.parentElement.clientWidth ? _mx - _tw - 10 : _mx + 10) + 'px';
            tooltip.style.top     = (e.clientY - rect.top - 24) + 'px';
        } else if (tooltip) {
            tooltip.style.display = 'none';
        }
    };
    canvas._predML = () => { if (tooltip) tooltip.style.display = 'none'; };
    canvas.addEventListener('mousemove',  canvas._predMM);
    canvas.addEventListener('mouseleave', canvas._predML);
}
